import { render, staticRenderFns } from "./originalList.vue?vue&type=template&id=5a946220&scoped=true&"
import script from "./originalList.vue?vue&type=script&lang=js&"
export * from "./originalList.vue?vue&type=script&lang=js&"
import style0 from "./originalList.vue?vue&type=style&index=0&id=5a946220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a946220",
  null
  
)

export default component.exports